<template>
  <mu-popup position="bottom" :open="open" popupClass="kkt-date-picker" @close="close" style="width: 100%">
    <div style="text-align: right; background: #eff2f7">
      <mu-flat-button label="取消" :color="'#4594fb'" @click="close" style="float: left"></mu-flat-button>
      <mu-flat-button label="确认" :color="'#4594fb'" @click="sure"></mu-flat-button>
    </div>
    <mu-content-block>
      <mu-picker :slots="slots" :visible-item-count="5"  @change="dateChange" :values="dateValues"></mu-picker>
    </mu-content-block>
  </mu-popup>
</template>

<script>
  import _ from 'lodash'
  export default {
    props: {
      value: {
        type: String,
        default: Date.format()
      },
      // 开始时间
      startDate: {
        type: [String, Date],
        default () {
          return new Date(0)
        }
      },
      // 结束时间
      endDate: {
        type: [String, Date],
        default () {
          return new Date()
        }
      },
      // 禁止显示月份
      disableM: {
        type: Boolean,
        default: false
      },
      // 禁止显示天数
      disableD: {
        type: Boolean,
        default: false
      }
    },

    data () {
      return {
        open: false,
        slots: [],
        dateValues: [],
        currentValues: [],
        years: [],
        days: [],
        currentMonthes: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
        monthes: [],
        start: null,
        end: null
      }
    },

    computed: {
      dateSlots () {
        let arr = [
          {
            width: '100%',
            textAlign: 'center',
            values: _.cloneDeep(this.years)
          }
        ]
        if (!this.disableM) {
          arr.push({
            width: '100%',
            textAlign: 'center',
            values: _.cloneDeep(this.monthes)
          })
          if (!this.disableD) {
            arr.push({
              width: '100%',
              textAlign: 'center',
              values: _.cloneDeep(this.days)
            })
          }
        }
        return arr
      }
    },

    created () {
      this.start = this.startDate
      this.end = this.endDate
      // 兼容Safari浏览器
      if (typeof(this.start) === 'string') {
        this.start = Date.formatString(this.start)
      }
      if (typeof(this.end) === 'string') {
        this.start = Date.formatString(this.end)
      }
      // 初始化需要显示的日期
      this.initValue(this.value)
      // 获取年份
      this.years = Array.apply(null, {length: this.end.getFullYear() - this.start.getFullYear() + 1}).map((item, index) => index +  this.start.getFullYear() + '').reverse()
      let date = new Date(parseInt(this.currentValues[0]), parseInt(this.currentValues[1]), 0)
      // 获取月份
      if (!this.disableM || !this.disableD) {
        this.getMonthes()
        this.getDays()
      }
    },

    watch: {
      value (val) {
        this.initValue(val)
      },

      years (val, oldVal) {
        this.renderData(val, oldVal)
      },

      monthes (val, oldVal) {
        this.renderData(val, oldVal)
      },

      days (val, oldVal) {
        this.renderData(val, oldVal)
      }
    },

    methods: {
      initValue (val) {
        this.dateValues = Date.format(val).split('-')
        this.currentValues = _.cloneDeep(this.dateValues)
      },

      show () {
        this.open = true
      },

      close () {
        this.open = false
      },

      sure () {
        let data = this.dateValues.join('-')
        if (this.disableM) {
          data = this.dateValues[0]
        } else {
          if (this.disableD) {
            data = [this.dateValues[0], this.dateValues[1]].join('-')
          }
        }
        this.open = false
        this.$emit('on-change', data)
      },

      /*
      * 数据重新渲染
      */
      renderData (val, oldVal) {
        let flag = true
        val.forEach((item, index) => {
          if (item !== oldVal[index]) flag = false
        })
        if (val.length !== oldVal.length) flag = false
        if (flag === false) {
          this.slots = []
          this.$nextTick(() => {
            this.slots = _.cloneDeep(this.dateSlots)
          })
        }
      },

      /*
      * 时间选择
      * @param {String, Number} value index(0: 年, 1: 月, 2: 日) 
      */
      dateChange (value, index) {
        this.currentValues[index] = value
        if (!this.disableM || !this.disableD) {
          this.getMonthes()
          this.getDays()
        }
        this.dateValues = _.cloneDeep(this.currentValues)
      },

      /*
      * 获取当年月份
      */
      getMonthes () {
        let monthes = []
        if (parseInt(this.currentValues[0]) === this.end.getFullYear()) {
          monthes = this.currentMonthes.filter(month => parseInt(month) <= this.end.getMonth() + 1)
          if (monthes.indexOf(this.currentValues[1]) === -1) {
            this.currentValues[1] = monthes[monthes.length - 1]
          }
        } else if (parseInt(this.currentValues[0]) === this.start.getFullYear()) {
          monthes = this.currentMonthes.filter(month => parseInt(month) >= this.start.getMonth() + 1)
          if (monthes.indexOf(this.currentValues[1]) === -1) {
            this.currentValues[1] = monthes[0]
          }
        } else {
          monthes = _.cloneDeep(this.currentMonthes)
        }
        this.dateValues = _.cloneDeep(this.currentValues)
        this.monthes = monthes
      },

      /*
      * 获取当月日期
      */
      getDays () {
        let date = new Date(parseInt(this.currentValues[0]), parseInt(this.currentValues[1]), 0)
        let days = Array.apply(null, {length: date.getDate()}).map((item, index) => index + 1 < 10 ? '0' + (index + 1) : index + 1 + '')
        if (parseInt(this.currentValues[0]) === this.end.getFullYear() && parseInt(this.currentValues[1]) - 1 === this.end.getMonth()) {
          days = days.filter(day => day <= this.end.getDate())
          if (days.indexOf(this.currentValues[2]) === -1) {
            this.currentValues[2] = days[days.length - 1]
          }
        } else if (parseInt(this.currentValues[0]) === this.start.getFullYear() && parseInt(this.currentValues[1]) - 1 === this.start.getMonth()) {
          days = days.filter(day => day >= this.start.getDate())
          if (days.indexOf(this.currentValues[2]) === -1) {
            this.currentValues[2] = days[0]
          }
        }
        this.days = days
      }
    }
  }
</script>

<style>
  .kkt-date-picker {
    width: 100%
  }
</style>


// WEBPACK FOOTER //
// src/components/KktDatePicker.vue